/* tslint:disable */
/* eslint-disable */
/**
 * Cushla API
 * REST API for Cushla
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export enum HomeType {
  HOMELESS = 'HOMELESS',
  APARTMENT_WITH_STAIRS = 'APARTMENT_WITH_STAIRS',
  APARTMENT_WITH_LIFT = 'APARTMENT_WITH_LIFT',
  BUNGALOW = 'BUNGALOW',
  HOUSE_WITH_STAIRS = 'HOUSE_WITH_STAIRS',
  MOBILE_HOME = 'MOBILE_HOME',
}
